import SvgClose from './SvgClose';

export default SvgClose;
